import axios from "axios";

axios.defaults.baseURL = "https://roshi-chat.herokuapp.com"; 
// axios.defaults.baseURL = "http://localhost:4000"; 
// axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL; 

export const generateResumePDF = async (body) => {
    let res = await axios.post("/resume/doc/generate", body);
    return res.data;
}